// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---node-modules-gatsby-plugin-offline-app-shell-js": () => import("/Users/maigo999/gatstrap/node_modules/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---node-modules-gatsby-plugin-offline-app-shell-js" */),
  "component---src-templates-index-js": () => import("/Users/maigo999/gatstrap/src/templates/index.js" /* webpackChunkName: "component---src-templates-index-js" */),
  "component---src-pages-index-js": () => import("/Users/maigo999/gatstrap/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-profile-js": () => import("/Users/maigo999/gatstrap/src/pages/Profile.js" /* webpackChunkName: "component---src-pages-profile-js" */)
}

exports.data = () => import("/Users/maigo999/gatstrap/.cache/data.json")

